import { BRAND, CONTACT } from "@/lib/brand";
import { Link } from "react-router-dom";
import { Instagram, Facebook, MessageCircle, Mail, Phone } from "lucide-react";

const QUICK = [
  { id: "home", label: "Home" },
  { id: "store", label: "Store Details" },
  { id: "collections", label: "Our Collections" },
  { id: "instagram", label: "Instagram" },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative pt-20 pb-8 text-white overflow-hidden"
      style={{
        background:
          "linear-gradient(160deg, #0b2140 0%, #1e1b4b 40%, #2b0b47 100%)",
      }}
    >
      <div
        className="absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full opacity-25 blur-3xl"
        style={{
          background: "radial-gradient(circle, #cb05a5 0%, transparent 70%)",
        }}
      />
      <div
        className="absolute -bottom-24 -left-24 w-[420px] h-[420px] rounded-full opacity-25 blur-3xl"
        style={{
          background: "radial-gradient(circle, #299fe0 0%, transparent 70%)",
        }}
      />

      <div className="relative mx-auto max-w-6xl px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <img
                src={BRAND.logo}
                alt={BRAND.fullName}
                className="w-12 h-12 rounded-full ring-2 ring-white/40"
              />
              <div>
                <div className="font-display font-black text-xl">
                  Sky Basket
                </div>
                <div className="text-xs uppercase tracking-[0.22em] text-[#f8bce8]">
                  Stationery · Gifts
                </div>
              </div>
            </div>
            <p className="mt-5 text-white/70 leading-relaxed max-w-md">
              A neighbourhood stationery boutique in New Chandigarh — curating
              journals, fine writing instruments, gift wrapping essentials and
              desk accessories worth writing home about.
            </p>

            <div className="mt-6 flex items-center gap-3">
              <a
                href={CONTACT.instagramUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href={CONTACT.facebookUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-facebook"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href={`https://wa.me/${CONTACT.whatsappNumber}`}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle size={18} />
              </a>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.25em] font-semibold text-white/60">
              Quick Links
            </div>
            <div className="mt-5 flex flex-col gap-2">
              {QUICK.map((q) => (
                <a
                  key={q.id}
                  href={`#${q.id}`}
                  className="text-white/85 hover:text-[#f8bce8] transition-colors"
                >
                  {q.label}
                </a>
              ))}
              <Link
                to="/admin/login"
                data-testid="footer-staff-login"
                className="text-white/85 hover:text-[#f8bce8] transition-colors"
              >
                Staff Login
              </Link>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.25em] font-semibold text-white/60">
              Contact
            </div>
            <div className="mt-5 space-y-3 text-white/85">
              <div className="text-sm leading-relaxed">
                {CONTACT.address}
              </div>
              <a
                href={`tel:${CONTACT.phoneDial}`}
                className="flex items-center gap-2 text-sm hover:text-[#f8bce8]"
              >
                <Phone size={14} /> {CONTACT.phone}
              </a>
              <a
                href={`mailto:${CONTACT.email}`}
                className="flex items-center gap-2 text-sm hover:text-[#f8bce8]"
              >
                <Mail size={14} /> {CONTACT.email}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <div>© 2026 Sky Basket Stationery & Gifts. All Rights Reserved.</div>
          <div>Crafted with care in New Chandigarh.</div>
        </div>
      </div>
    </footer>
  );
}
